import { cashbackApi } from '@api/index';
import { usePaginationQuery } from '@hooks/usePaginationQuery';
import { QUERIES } from '@query/queries';

export const useCashbackHistoryQuery = () => {
  return usePaginationQuery([QUERIES.CASHBACK_HISTORY], (query) => cashbackApi.getHistory(query));
};
